<template>
    <div>
        <div v-if="this.rmData['RoleId']=='1'">
        <innerheader />
      </div>
      <div v-else>
      <innerheaderDIY/>
      </div>
        <proposaladdresscheck />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheaderDIY from "@/components/innerheader/innerHeaderDIY.vue";
import innerheader from "@/components/innerheader/innerheader.vue";
import proposaladdresscheck from "@/components/proposal/proposal-details-check-diy.vue";

export default {
  name:' proposaldetailscheckdiy',
  components: {
      innerheader,
     innerheaderDIY,
     proposaladdresscheck
  },
  data()
  {
    return{
      rmData:"",
    }
  },
   mounted()
  {
     if(sessionStorage.getItem("rm_data"))
     {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
     }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/checkout.scss';
@import '~@/assets/scss/components/proposal-page.scss';
</style>